import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import TeamSlider from "../common/Slider/Carousel";
import { useNavigate } from "react-router-dom";
import bannerVideo from "../assets/images/banner/banner-bg.mp4";

const Banner = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="relative font-sans text-[#212529] text-center p-5 pb-6">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 z-0 w-full h-full object-cover opacity-40"
      >
        <source src={bannerVideo} type="video/mp4" />
        Tarayıcınız video etiketini desteklemiyor.
      </video>
      {/* Ana İçerik Alanı - Container içinde */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="flex justify-center items-center pt-20 pb-6">
          
          {/* Metin Alanı - Ortalanmış */}
          <div className="text-center max-w-4xl">
            <h1 className="text-[20px] md:text-[24px] lg:text-[28px] text-[#212529] font-roboto font-bold leading-tight mb-4 px-4">
              {t("startTheChangeWithOnlineTherapy")}
            </h1>
            
            <p className="text-[12px] md:text-[16px] lg:text-[20px] text-[#212529] font-roboto font-bold mb-8 lg:mb-12 px-4">
              Confidential. Professional. Accessible. <br />
               Better Mind, Brighter Life.
            </p>

            <Button
              variant="contained"
              onClick={() => navigate("/experts")}
              sx={{
                width: { xs: 180, lg: 250 },
                height: { xs: 45, lg: 60 },
                fontSize: { xs: 16, lg: 20 },
                color: "#ffffff",
                backgroundImage: "linear-gradient(to right, #625480, #E5D3DD)",
                borderRadius: "50px",
                boxShadow: 3,
                borderBottomWidth: 4,
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  filter: "brightness(1.1)",
                  transform: "translateY(-1px)",
                  borderBottomWidth: 6,
                },
                "&:active": {
                  filter: "brightness(0.9)",
                  transform: "translateY(2px)",
                  borderBottomWidth: 2,
                },
              }}
            >
              {t("startNow")}
            </Button>

            {/* Language Strip */}
            <div className="mt-8 flex justify-center">
              <div className="bg-white/70 backdrop-blur-md border border-[#625480]/20 rounded-2xl px-6 py-4 shadow-md">
                <p className="text-[11px] md:text-[12px] text-[#625480] font-semibold uppercase tracking-widest mb-3">
                  {t("therapyInYourLanguage")}
                </p>
                <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2">
                  {["English", "Türkçe", "العربية", "كوردی", "Español", "Français"].map((lang, i, arr) => (
                    <React.Fragment key={lang}>
                      <span className="text-[14px] md:text-[15px] font-medium text-[#212529]/80">
                        {lang}
                      </span>
                      {i < arr.length - 1 && (
                        <span className="text-[#625480] opacity-40 text-sm">·</span>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
            {/* Corner Highlight - Mobile & Tablet */}
            <div className="mt-10 lg:hidden mx-auto max-w-md">
              <div className="bg-white/85 backdrop-blur-md border border-[#62548024] shadow-lg rounded-3xl px-5 py-4 text-left">
                <p className="text-[16px] font-semibold text-[#2d465e] leading-relaxed">
                  Online therapy with expert Child & Adolescent Therapists, Adult Therapists, and Couple & Family Therapists.
                </p>
                <p className="mt-2 text-[14px] font-medium text-[#625480]">
                  One platform, every therapist you need.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Team Slider */}
      <div className="relative z-10 mt-4 md:mt-6">
        <TeamSlider />
      </div>
    </div>
  );
};

export default Banner;
